import React from 'react';
import { useTranslation } from 'react-i18next';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import { AppUtils } from '@gscope-mfe/app-bridge';
import { Utilities } from '@gscope-mfe/app-bridge';
import Loader from '../Loader';
import { Services } from '@gscope-mfe/app-bridge';
const { MenuItem } = MaterialUiCore;
const { Select } = MaterialUiCore;
const { FormControl } = MaterialUiCore;
const { getUserPreferences, setUserPreference } = Utilities;
const { getSupportedLngs } = Services;

const LanguageSelector = () => {
    const { i18n } = useTranslation();
    const { allLangs, setPrefLang } = AppUtils.get();
    const [currentLang, setCurrentLang] = React.useState('');
    const [supportedlngs, setSupportedLngs] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(true);
    const appPref = 'appPreferences';

    const getSelectedLang = async (langs, appP) => {
        // playground: {language: {lang: "en"}}
        const userPref = await getUserPreferences(true);
        let lang;

        if (userPref && userPref[appP] && userPref[appP].prefLang && langs.includes(userPref[appP].prefLang.lang)) {
            lang = userPref[appP].prefLang.lang;
        } else {
            lang = langs.includes('en') ? 'en' : langs[0];
        }

        return lang;
    };

    React.useEffect(() => {
        if (allLangs && allLangs.length > 0) {
            getSelectedLang(allLangs, appPref).then((lang) => {
                i18n.changeLanguage(lang)
                    .then((t) => {
                        setIsLoading(false);
                        setCurrentLang(lang);
                        setPrefLang &&
                            setPrefLang({
                                previous: 'default',
                                current: lang,
                            });
                    })
                    .catch(() => {
                        setIsLoading(false);
                    });
            });
            getSupportedLngs().then((res) => {
                const lngs = JSON.parse(JSON.stringify(res.data));

                if (lngs) {
                    setSupportedLngs(lngs);
                }
            });
        }
    }, [allLangs]);

    const changeLanguage = (event) => {
        const lang = event.target.value;

        if (lang !== currentLang) {
            setIsLoading(true);
            i18n.changeLanguage(lang)
                .then((t) => {
                    setPrefLang &&
                        setPrefLang({
                            previous: currentLang,
                            current: lang,
                        });
                    setIsLoading(false);
                    setCurrentLang(lang);
                })
                .catch(() => {
                    setIsLoading(false);
                });
            const reqPayload = {
                pageName: appPref,
                key: 'prefLang',
                value: {
                    lang,
                },
            };
            setUserPreference(reqPayload);
        }
    };

    return (
        <div>
            {allLangs && allLangs.length > 0 && (
                <FormControl variant="outlined">
                    <Loader show={isLoading} />
                    <Select name="Languages" value={currentLang} onChange={changeLanguage}>
                        {allLangs.map((lang) => (
                            <MenuItem key={lang} value={lang}>
                                {supportedlngs[lang] ? supportedlngs[lang] : lang.toLowerCase()}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        </div>
    );
};

export default LanguageSelector;
